import { DateTime } from "luxon";

/**
 * The API types its timestamps as Java LocalDateTime, which carries no zone.
 * Its parser accepts a bare wall clock (and a trailing Z) but rejects the
 * numeric offset Luxon's toISO() appends, so the offset is dropped here.
 */
export function toLocalDateTime(date: DateTime): string {
  return date.toISO({ includeOffset: false })!;
}

/**
 * A purchase is dated by day, but the server compares against its own clock:
 * midnight of "today" reads as the future to a server running behind the
 * client. Today therefore sends the current time, past days their midnight.
 */
export function purchaseInstant(day: string): string {
  const parsed = DateTime.fromISO(day);
  if (!parsed.isValid) return toLocalDateTime(DateTime.now());

  const now = DateTime.now();
  return toLocalDateTime(parsed.hasSame(now, "day") ? now : parsed.startOf("day"));
}

/**
 * An expiry is dated by day too, and a batch expiring today is still good
 * until the evening — so it lands at the end of that day, which also keeps
 * the server's "must be in the future" check happy.
 */
export function expiryInstant(day: string): string | undefined {
  const parsed = DateTime.fromISO(day);
  return parsed.isValid ? toLocalDateTime(parsed.endOf("day")) : undefined;
}
